<template>
  <div id="blog">
    <v-title title="Lexi's Kitchen Blog | Cooking, Living, etc."></v-title>
    <h1>Blog</h1>
    <div class="blogcontainer">
      <div class="blogpost" v-for="(post, key) in posts" :key="key">
        <router-link :to="'/blog/' + post.slug.S">
          <div class="imagecontainer" v-bind:style="{ backgroundImage: 'url(' + post.featuredImage.S + ')'}" v-if="post.featuredImage">
          </div>
          <div class="imagecontainer nofeature" v-if="!post.featuredImage">
          </div>
        </router-link>
        <div class="post-text">
          <router-link :to="'/blog/' + post.slug.S">
            <h2 class="posttitle">{{ post.title.S }}</h2>
          </router-link>
          <p class="excerpt">{{post.excerpt.S}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vTitle from '../components/v-title';

export default {
  name: 'Blog',
  components: {
    'v-title': vTitle
  },
  computed: {
    posts() {
      return this.$store.state.posts.filter(post => {
        return post.status.S === 'Published'
      })
    }
  },
  beforeMount() {
    if (!this.$store.state.posts.length) {
      this.getPosts()
    }
    this.$store.commit('setHeaderClass', 'wide');
  },
  methods: {
    async getPosts() {

      const init = {
        headers: {
          "Content-Type": 'application/json',
          "X-Api-Key": "NhLutvx5gP2646WFTQ8Ds1i8jHqQ0fILaHUZ7hEs",
        }
      }

      const apiurl = 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev/blog/get'

      axios
        .get(apiurl, init)
        .then( response => {
          console.log(response);
          let posts = [];
          for (let i = 0; i < response.data.length; i++) {
            let post = response.data[i]
            if (post.status.S != 'Draft') {
              posts.push(post);
            }
          }
          for (let i = 0; i < posts.length; i++) {
            let post = posts[i]
            if (post.featuredImage) {
              post.bgStyle = `background-image: ${post.featuredImage.S}`
            }
          }
          this.$store.commit('addPostData', posts)
        })
    }
  }
}
</script>

<style scoped lang="scss">

  #blog {
    max-width: 1000px;
    margin: auto;
  }
  .blogcontainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
  }

  .blogpost {
    display: grid;
    grid-template-rows: 1fr auto;
    height: 300px;
    box-shadow: 0 0 10px #c1c1c1;
  }

  a {
    text-decoration: none;
    color: #000000;
  }

  .posttitle {
    border-bottom: 1px solid #b5b5b5;
    padding: 0 10px;
  }
  .excerpt {
    padding: 0 10px;
  }

  .imagecontainer {
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  .nofeature {
    background-image: url("https://s3.amazonaws.com/lexikitchen/lexi-kitchen-solid-icon.png");
  }

  @media (max-width: 900px) {
    .blogpost {
      padding: 15px;
    }
  }

  @media (max-width: 700px) {
    .blogcontainer {
      grid-template-columns: 1fr;
    }
  }

</style>
